import Dashboard from "../modules/admin/dashboard";
import UserList from "../modules/admin/user-list";
import TrainAI from "../modules/admin/train-ai";
import AIChatSessions from "../modules/admin/ai-chat-sessions";
import BillingCoupons from "../modules/admin/billing-coupons";

export const Admins = [
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "manage-user",
    element: <UserList />,
  },
  {
    path: "train-ai",
    element: <TrainAI />,
  },
  {
    path: "ai-chat-sessions",
    element: <AIChatSessions />,
  },
  {
    path: "billing-coupons",
    element: <BillingCoupons />,
  },
];
